import { flattenByField } from "../../../utils/array";

export const isRouteLocked = (routes, selectedRouteId) =>
  flattenByField(routes, "value").find((item) => item.value === selectedRouteId)
    ?.locked;
